import { useState } from 'react';
import TBodyRow from './TBodyRow';

interface IProps {
  compartmentData: any;
  handleCompartmentData: any;
  handlePartAddModal: any;
  isView: boolean;
}
const TBody = ({
  isView,
  compartmentData,
  handleCompartmentData,
  handlePartAddModal,
}: IProps) => {
  return (
    <tbody>
      {compartmentData?.map((item: any, index: number) => (
        <TBodyRow
          {...{ item, index, handleCompartmentData, handlePartAddModal }}
        />
      ))}
    </tbody>
  );
};

export default TBody;
